import { render, staticRenderFns } from "./VideoMeetingCard.vue?vue&type=template&id=82348362&"
import script from "./VideoMeetingCard.vue?vue&type=script&lang=js&"
export * from "./VideoMeetingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports